export default request => ({
  get(query = "") {
    return request({
      path: "search/?searchTerm=" + query,
      method: "get"
    });
  }
});
